import { SelectionModel } from '@angular/cdk/collections';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { RequestItemInDashboard } from 'src/app/models/dashboard';
import { RequestFilter } from 'src/app/models/requestfilter';
import { FilterPipe } from 'src/app/pipes/filter.pipe';
import { PlatformHubService } from 'src/app/services/platformhub.service';
import { SessionStorageService } from 'src/app/services/session-storage.service';

@Component({
  selector: 'app-request-table',
  templateUrl: './request-table.component.html'
})
export class RequestTableComponent implements OnInit {
  private _requests!: RequestItemInDashboard[];
  @Input() set requests(val: RequestItemInDashboard[]) {
    this._requests = val;
    this.filteredRequests = this.requests.filter(request => request.status.toLowerCase() !== "expired");
  };
  get requests(): RequestItemInDashboard[] {
    return this._requests;
  }

  @Input() filter: RequestFilter = <RequestFilter>{};
  @Input() workgroup: boolean = false;
  @Output() selectionChanged = new EventEmitter<RequestItemInDashboard[]>();
  selection = new SelectionModel<RequestItemInDashboard>(true, []);
  currentPage: any = localStorage.getItem('requests.activityListPage') ? localStorage.getItem('requests.activityListPage') : 1;
  itemsPerPage: any = localStorage.getItem('requests.activityListSize') ? localStorage.getItem('requests.activityListSize') : 10;
  descending: boolean = true;
  filterMetadata = { count: -1 };
  filteredRequests: RequestItemInDashboard[] = [];
  pageSize!: number;
  filterpipe: FilterPipe = new FilterPipe;
  selectionChangedSubscription!: Subscription;
  showAll: boolean = false;

  orderBy: string = 'desc';
  columnName: string = 'lastUpdate';

  constructor(public platformHubService: PlatformHubService, private sessionStorageService: SessionStorageService) {
    // empty constuctor
  }

  ngOnInit(): void {
    this.filteredRequests = this.requests.filter(request => (request.status != undefined && request.status != null && request.status.toLowerCase() !== "expired"));
    this.selectionChangedSubscription = this.selection.changed.subscribe(() => {
      this.selectionChanged.emit(this.selection.selected);
    });
    let ShowAllDocsInOrg = sessionStorage.getItem("ShowAllDocsInOrg");
    if (ShowAllDocsInOrg != undefined && ShowAllDocsInOrg != null && ShowAllDocsInOrg != "false") {
      this.showAll = true;
    } else {
      this.showAll = false;
    }
    // Grab Session stored:
    this.orderBy = this.sessionStorageService.sortingDirection;
    this.columnName = this.sessionStorageService.sortingColumnName;
  }

  onDestroy() {
    this.selectionChangedSubscription.unsubscribe();
  }
  onPageChanged(pageNum: any): void {
    this.pageSize = this.itemsPerPage * (pageNum - 1);
    localStorage.setItem("requests.activityListPage", pageNum);
  }

  changePagesize(num: any): void {
    this.itemsPerPage = num;
    localStorage.setItem("requests.activityListSize", num);
  }

  sortData(column: string) {
    // store it for this session

    if (this.columnName == column) {
      this.descending = !this.descending;
    } else {
      this.columnName = column;
      this.sessionStorageService.sortingColumnName = this.columnName;
      this.descending = false;
    }
    this.sessionStorageService.sortDescending = this.descending;
    this.orderBy = this.sessionStorageService.sortingDirection;
  }

  masterToggle() {
    if (this.isAllSelected()) {
      this.selection.clear();
    } else {
      this.selection.clear();
      this.getFilteredRequests()!.forEach((row: RequestItemInDashboard) => this.selection.select(row));
    }
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.getFilteredRequests().length;
    return numSelected === numRows;
  }

  getFilteredRequests() {
    return this.filterpipe.transform(this.requests, this.filterMetadata)
  }

  public clearSelection() {
    this.selection.clear();
  }

  userHasRequestsInWorkgroup() {
    return this.platformHubService.RequestsInWorkgroup;
  }
}
